import { fetcher, SHOW_ERROR_PAGE_ON_FETCH_FAIL } from '@features/common';

/**
 * Active, non-terminated employees with their departments.
 * Failures are shown on the page itself, not as the global error screen.
 */
export function fetchOrganizationChart() {
  return fetcher.get('/api/v1/hr/organization-chart', {
    meta: { [SHOW_ERROR_PAGE_ON_FETCH_FAIL]: false },
  });
}
